import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import Recommender from './Components/RecommenderRoute/Recommender';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import PacksProvider from './Components/Context/PacksContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function RecommenderRoute() {
    return (
        <UserInfoProvider>
            <PacksProvider>
                <MedicalContextProvider>
                    <div className="RecommenderRoutePage">
                        <div className="RecommenderRouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="RecommenderRoute">
                            <Recommender/>
                        </div>
                        {/*<div className="RecommenderRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </PacksProvider>
        </UserInfoProvider>
    );
}

export default RecommenderRoute;